/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Happy_Swan_TasteInputs */

const fr_close_happy_swan_taste = /** @type {(inputs: Close_Happy_Swan_TasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as des séances non terminées. N'hésites pas a les finir.`)
};

/**

* @param {Close_Happy_Swan_TasteInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const close_happy_swan_taste = /** @type {((inputs?: Close_Happy_Swan_TasteInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Happy_Swan_TasteInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_close_happy_swan_taste(inputs)
});